import { render } from "./CertMedicalPending.vue?vue&type=template&id=481053a7&scoped=true"
import script from "./CertMedicalPending.vue?vue&type=script&lang=js"
export * from "./CertMedicalPending.vue?vue&type=script&lang=js"

import "./CertMedicalPending.vue?vue&type=style&index=0&id=481053a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481053a7"]])

export default __exports__